import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/views/common/Layout.vue'
import { generateThemeRoutes, loadTheme } from '@/themes/loader'
import { getAvailableThemes, getThemeConfig } from '@/themes'
import request from '@/utils/request'

// 默认路由配置（保留向后兼容）
const defaultRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/kpzp',
    children: [
      {
        path: 'activity',
        name: 'ActivityList',
        component: () => import('@/views/activity/ActivityList.vue'),
        meta: { title: '活动列表' }
      },
      {
        path: 'activity/:id',
        name: 'ActivityDetail',
        component: () => import('@/views/activity/ActivityDetail.vue'),
        meta: { title: '活动详情' }
      },
      {
        path: 'activity/:id/register',
        name: 'ActivityRegister',
        component: () => import('@/views/registration/RegisterForm.vue'),
        meta: { title: '活动报名' }
      },
      {
        path: 'activity/:id/work-submit',
        name: 'WorkSubmit',
        component: () => import('@/views/work/WorkSubmit.vue'),
      },
      {
        path: 'gallery',
        name: 'Gallery',
        component: () => import('@/views/gallery/Gallery.vue'),
        meta: { title: '作品展示' }
      },
      {
        path: 'gallery/:id',
        name: 'WorkDetailOld',
        meta: { title: '作品详情' }
      },
      {
        path: 'work/detail/:id',
        name: 'WorkDetail',
        component: () => import('@/views/gallery/WorkDetail.vue'),
        meta: { title: '作品详情' }
      },
      // 用户中心（在Layout内）
      {
        path: 'user/center',
        name: 'UserCenter',
        component: () => import('@/views/user/UserCenter.vue'),
        meta: { title: '个人中心', requiresAuth: true }
      },
      {
        path: 'user/works',
        name: 'MyWorks',
        component: () => import('@/views/user/MyWorks.vue'),
        meta: { title: '我的作品', requiresAuth: true }
      }
    ]
  },
  // 认证相关页面（无需Layout）
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/Register.vue'),
    meta: { title: '注册' }
  },
  // 活动宣传页
  {
    path: '/promo/:id',
    name: 'ActivityPromo',
    component: () => import('@/views/activity/ActivityPromo.vue'),
    meta: { title: '活动宣传' }
  },
  { path: '/:tenantCode/admin/login', name: 'TenantLogin', component: () => import('@/views/tenant-admin/Login.vue'), meta: { title: '管理端登录' } },
  { path: '/:tenantCode/admin/register', name: 'TenantRegister', component: () => import('@/views/tenant-admin/Register.vue'), meta: { title: '管理员注册' } },
  // ============ 租户管理端（独立登录页 + 管理布局） ============
  {
  path: '/:tenantCode/admin',
  component: () => import('@/views/tenant-admin/TenantAdminLayout.vue'),
  children: [
    { path: '', name: 'TenantDashboard', component: () => import('@/views/tenant-admin/DashboardRouter.vue'), meta: { title: '工作台', requiresAdmin: true } },
    { path: 'activities', name: 'TenantActivities', component: () => import('@/views/tenant-admin/ActivityList.vue'), meta: { title: '活动管理', requiresAdmin: true } },
    { path: 'works', name: 'TenantWorks', component: () => import('@/views/tenant-admin/WorkList.vue'), meta: { title: '作品管理', requiresAdmin: true } },
    { path: 'works/:id', name: 'TenantWorkDetail', component: () => import('@/views/tenant-admin/WorkDetail.vue'), meta: { title: '作品详情', requiresAdmin: true } },
    { path: 'experts', name: 'TenantExperts', component: () => import('@/views/tenant-admin/ExpertList.vue'), meta: { title: '专家管理', requiresAdmin: true } },
    { path: 'reviews', name: 'TenantReviews', component: () => import('@/views/tenant-admin/ExpertReviewList.vue'), meta: { title: '评审管理', requiresAdmin: true } },
    { path: 'comments', name: 'TenantComments', component: () => import('@/views/tenant-admin/CommentList.vue'), meta: { title: '评论审核', requiresAdmin: true } },
    { path: 'form-config/:activityId', name: 'TenantFormConfig', component: () => import('@/views/tenant-admin/ActivityFormConfig.vue'), meta: { title: '表单配置', requiresAdmin: true } },
    // 评审指标配置（tenant_id=0 为系统预置模板）
    { path: 'criteria', name: 'TenantCriteriaConfig', component: () => import('@/views/tenant-admin/criteria/CriteriaConfig.vue'), meta: { title: '评审指标配置', requiresAdmin: true } },
      { path: 'users', name: 'TenantUsers', component: () => import('@/views/tenant-admin/UserList.vue'), meta: { title: '用户管理', requiresAdmin: true } },
      { path: 'roles', name: 'TenantRoles', component: () => import('@/views/tenant-admin/RoleList.vue'), meta: { title: '角色管理', requiresAdmin: true } },
      { path: 'menus', name: 'TenantMenus', component: () => import('@/views/tenant-admin/MenuList.vue'), meta: { title: '菜单管理', requiresAdmin: true } },
      { path: 'dict', name: 'TenantDict', component: () => import('@/views/tenant-admin/DictList.vue'), meta: { title: '字典管理', requiresAdmin: true } },
      { path: 'first-reviews', name: 'TenantFirstReviews', component: () => import('@/views/tenant-admin/FirstReviewList.vue'), meta: { title: '推荐管理', requiresAdmin: true } },
      { path: 'stage-config', name: 'TenantStageConfig', component: () => import('@/views/tenant-admin/StageConfig.vue'), meta: { title: '阶段配置', requiresAdmin: true } },
      { path: 'dept', name: 'TenantDept', component: () => import('@/views/tenant-admin/DeptList.vue'), meta: { title: '部门管理', requiresAdmin: true } },
      { path: 'reg-users', name: 'TenantRegUsers', component: () => import('@/views/tenant-admin/RegUserList.vue'), meta: { title: '注册用户管理', requiresAdmin: true } },
      { path: 'print-template/list', name: 'TenantPrintTemplateList', component: () => import('@/views/tenant-admin/print-template/PrintTemplateList.vue'), meta: { title: '打印模板', requiresAdmin: true } },
      { path: 'system-config', name: 'TenantConfigList', component: () => import('@/views/tenant-admin/config/ConfigList.vue'), meta: { title: '系统配置', requiresAdmin: true } },
      { path: 'quota-config', name: 'TenantQuotaConfig', component: () => import('@/views/tenant-admin/config/QuotaConfigList.vue'), meta: { title: '配额配置', requiresAdmin: true } },
      { path: 'unit-confirm', name: 'TenantUnitConfirm', component: () => import('@/views/tenant-admin/UnitConfirmList.vue'), meta: { title: '推荐确认', requiresAdmin: true } },
      { path: 'unit-confirm-records', name: 'TenantUnitConfirmRecords', component: () => import('@/views/tenant-admin/UnitConfirmAdminList.vue'), meta: { title: '确认记录', requiresAdmin: true } },
      { path: 'review-assign', name: 'TenantReviewAssign', component: () => import('@/views/tenant-admin/ReviewAssignManage.vue'), meta: { title: '初审分配管理', requiresAdmin: true } },

  ]
}
]

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes: defaultRoutes
})

// 动态加载主题路由
let themeRoutesLoaded = false

async function loadThemeRoutes() {
  if (themeRoutesLoaded) return
  
  try {
    // 从后端加载主题配置（使用配置的axios实例）
    console.log('[Theme] Loading theme config from /portal/theme/config')
    const result = await request({
      url: '/portal/theme/config',
      method: 'get'
    })
    console.log('[Theme] Theme config result:', result)
    
    if (result.code === 200 && result.data && result.data.length > 0) {
      // 为每个启用的主题生成路由
      for (const config of result.data) {
        // 重要：后端返回的配置中没有 routes 字段，需要从本地配置补充
        const themeCode = config.tenantCode || config.themeCode || config.code
        let localConfig = getAvailableThemes().find(t => t.code === themeCode || t.code === themeCode)
        if (!localConfig || !localConfig.routes) {
          // 未找到主题配置，使用 default 兜底
          localConfig = getThemeConfig('default')
          console.warn(`[Theme] No local config for ${themeCode}, using default fallback`)
        }
        if (localConfig && localConfig.routes) {
          config.code = themeCode; config.routes = localConfig.routes
          // 兜底主题的 routeBase 需要动态设为租户路径
          if (!config.routeBase) config.routeBase = '/' + themeCode
          console.log(`[Theme] Merged routes from local config for ${themeCode}, routeBase: ${config.routeBase}`)
        } else {
          console.warn(`[Theme] No default fallback config found, skipping ${themeCode}`)
          continue
        }
        
        const themeRoutes = generateThemeRoutes(config)
        
        // 动态添加主题路由
        themeRoutes.forEach(route => {
          console.log(`[Theme] Adding route: ${route.path}`)
          router.addRoute(route)
        })
        
        console.log(`[Theme] Loaded theme: ${config.themeName} (${config.themeCode})`)
      }
    } else {
      // 后端无数据，使用本地配置
      console.log('[Theme] No theme config from backend, using local config')
      loadFallbackThemeRoutes()
    }
    
    themeRoutesLoaded = true
  } catch (error) {
    console.warn('[Theme] Failed to load theme routes, using default routes:', error)
    // 降级：加载本地主题配置
    loadFallbackThemeRoutes()
  }
  
  // 确保 themeRoutesLoaded 被设置为 true（即使降级）
  themeRoutesLoaded = true
}

// 降级方案：加载本地主题配置
function loadFallbackThemeRoutes() {
  const themes = getAvailableThemes()
  
  themes.forEach(config => {
    if (!config.enabled) return
    
    const themeRoutes = generateThemeRoutes(config)
    
    themeRoutes.forEach(route => {
      router.addRoute(route)
    })
    
    console.log(`[Theme] Loaded local theme: ${config.name} (${config.code})`)
  })
  
  themeRoutesLoaded = true
}

// 路由守卫：处理认证和主题检测
router.beforeEach(async (to, from, next) => {
  // 动态主题兜底：如果路由未匹配且路径是 /:tenantCode 格式，使用 default 主题注册该租户的路由
  if (to.matched.length === 0) {
    const segments = to.path.split('/').filter(Boolean)
    if (segments.length >= 1) {
      const tenantCode = segments[0]
      // 检查是否已为该租户注册过路由
      const hasRoute = router.getRoutes().some(r => r.path.startsWith('/' + tenantCode + '/') || r.path === '/' + tenantCode)
      if (!hasRoute) {
        const localConfig = getThemeConfig('default')
        if (localConfig && localConfig.routes) {
          const themeConfig = { code: tenantCode, routeBase: '/' + tenantCode, routes: localConfig.routes }
          const themeRoutes = generateThemeRoutes(themeConfig)
          themeRoutes.forEach(route => { router.addRoute(route) })
          console.log(`[Theme] Dynamically added fallback routes for /${tenantCode}`)
          return next({ ...to, replace: true })
        }
      }
    }
  }

  // 管理端路由守卫
  if (to.meta.requiresAdmin) {
    const token = localStorage.getItem('tenant_token')
    const tc = to.params.tenantCode || ''
    if (!token) {
      return next({ name: 'TenantLogin', params: { tenantCode: tc || 'zero-carbon' } })
    }
    // 校验 token 是否属于当前租户
    const storedTenantCode = localStorage.getItem('tenant_code')
    if (tc) {
      if (!storedTenantCode || storedTenantCode !== tc) {
        // 无 tenant_code（旧版本登录）或租户不一致 → 强制重新登录
        localStorage.removeItem('tenant_token')
        localStorage.removeItem('tenant_code')
        return next({ name: 'TenantLogin', params: { tenantCode: tc } })
      }
    }
    // 权限检查：暂时关闭，调试菜单点击无效的问题
    // const adminRel = to.path.replace(/\/[^/]+\/admin\/?/, '')
    // if (adminRel && !isPathAllowed(adminRel)) {
    //   const tenantCode = to.params.tenantCode || 'zero-carbon'
    //   return next(`/${tenantCode}/admin`)
    // }
  }

  // 动态设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title + ' - 科普作品征集系统'
  } else if (to.meta.themeCode) {
    const themeConfig = getThemeConfig(to.meta.themeCode)
    if (themeConfig && themeConfig.name) {
      document.title = to.meta.title || themeConfig.name
    } else {
      document.title = '科普作品征集系统'
    }
  } else {
    document.title = '科普作品征集系统'
  }

  // 检查是否需要登录
  if (to.meta.requiresAuth || to.meta.auth) {
    const token = localStorage.getItem('c_token')
    if (!token) {
      // 判断是否为主题路由
      const themeCode = to.meta.themeCode
      let loginPath = '/login'
      
      if (themeCode) {
        // 主题路由：跳转到主题登录页
        loginPath = `/${themeCode}/login`
      } else if (to.path.startsWith('/zero-carbon')) {
        // 兼容旧路由
        loginPath = '/zero-carbon/login'
      }
      
      next({
        path: loginPath,
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  next()
})

// 导出路由实例和初始化函数
export default router
export { loadThemeRoutes }
